module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/incoming-call-652fb63ad8120ed28e5e0d488ef13d92.svg";